
<dashboardnav>
    <cradua-seismicdivision
    [seismicdivisions]="seismicdivisions$ | async"
    (seismicdivision)="onSubmitSeismicDivision($event)"
    (deleteSeismicDivisionEvent)="onDeleteSeismicDivision($event)"
    *ngIf="(isLoadingSeismicDivision$ | async ) === false"
    >
  </cradua-seismicdivision>

    <mrsoftapps-epims-reference-spinner
    *ngIf="(isLoadingSeismicDivision$ | async) === true"
  >
    </mrsoftapps-epims-reference-spinner>
    <!-- <pre>{{isLoading$ | async | json}}</pre> -->
  </dashboardnav>
